export const projectsItems = {
  filter: 'Фільтр',
};
